import { default as config } from "common/config/config";
import WindowEvent from "ui/common/utils/WindowEvent";
import { BaseFormScaffoldState } from "../FormScaffold.types";

export default class FormScaffoldResetEvent<T extends BaseFormScaffoldState> extends WindowEvent {
    static type = `${config.projectName}-clear-form-event`;
    state: T;

    constructor(state: T) {
        super(FormScaffoldResetEvent.type);
        this.state = state;
    }

    static addListener<T extends BaseFormScaffoldState>(callback: (event: FormScaffoldResetEvent<T>) => void): void {
        this.addListenerToWindow(FormScaffoldResetEvent.type, callback);
    }

    static removeListener<T extends BaseFormScaffoldState>(callback: (event: FormScaffoldResetEvent<T>) => void): void {
        this.removeListenerFromWindow(FormScaffoldResetEvent.type, callback);
    }

    static dispatch<T extends BaseFormScaffoldState>(state: T): void {
        this.dispatchEvent(new FormScaffoldResetEvent(state));
    }
}
